import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Detail } from 'components/shared/Detail/Detail'

import { MessageCircleIcon } from 'components/shared/Icon/model'
import { getCompetenciesLabels, getLanguageLabels } from './model'

import styles from './TemplateDetails.module.scss'

export const TemplateDetails = ({ activeTemplate, language }) => (
  <div className={styles.details}>
    <div className={styles.container}>
      <Detail>
        <Detail.LabelWithTooltip>{t`Title`}</Detail.LabelWithTooltip>
        <Detail.Content type="text">{activeTemplate?.name}</Detail.Content>
      </Detail>
      <Detail>
        <Detail.LabelWithTooltip>{t`Department`}</Detail.LabelWithTooltip>
        <Detail.Content type="text">
          {activeTemplate?.department?.name}
        </Detail.Content>
      </Detail>
      <Detail>
        <Detail.LabelWithTooltip
          tooltip={t`Selected language(s) will be available as options for candidate invitation and test language.`}
        >
          {t`Languages`}
        </Detail.LabelWithTooltip>
        <Detail.Content type="text">
          {getLanguageLabels(activeTemplate?.languages)}
        </Detail.Content>
      </Detail>
      {!R.isNil(activeTemplate?.interview_template) ? (
        <Detail>
          <Detail.LabelWithTooltip
            tooltip={t`The job template has an interview template connected to it.`}
          >
            {t`Interview`}
          </Detail.LabelWithTooltip>
          <Detail.Content icon={MessageCircleIcon} type="iconWithText">
            {activeTemplate?.interview_template}
          </Detail.Content>
        </Detail>
      ) : null}
      {R.pipe(
        R.values,
        R.any(R.equals(true)),
      )(activeTemplate?.profile?.categories) ? (
        <Detail>
          <Detail.LabelWithTooltip
            tooltip={t`The selected competencies that are most relevant to the job requirements. They determine how the calculation of test scores will be adjusted to favour relevant personality factors while the content of the candidate's tests remains unchanged.`}
          >
            {t`Competencies`}
          </Detail.LabelWithTooltip>
          <Detail.Content
            chips={getCompetenciesLabels(
              activeTemplate?.profile?.categories,
              language,
            )}
            type="chipsGroup"
          />
        </Detail>
      ) : null}
      {activeTemplate?.description ? (
        <Detail className={styles.description}>
          <Detail.LabelWithTooltip>{t`Description`}</Detail.LabelWithTooltip>
          <Detail.Content type="text">
            {activeTemplate?.description}
          </Detail.Content>
        </Detail>
      ) : null}
    </div>
  </div>
)
